import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { authSlice } from "./features/authSlice";
import { adminSlice } from "./features/adminSlice";
import { globalFuncSlice } from "./features/globalFuncSlice";
import studentAiSlice from "./features/studentAiSlice"; // Adjust path
import studentNotebookReducer from "./features/studentNotebookSlice";
import notificationPreferencesReducer from "./features/notificationPreferencesSlice";
import socialAccountsReducer from "./features/socialAccountsSlice";
import dashboardCardsReducer from "./features/dashboardCardsSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  admin: adminSlice.reducer,
  globalFunc: globalFuncSlice.reducer,
  studentAI: studentAiSlice, // Add studentAI reducer
  studentNotebook: studentNotebookReducer,
  notificationPreferences: notificationPreferencesReducer,
  socialAccounts: socialAccountsReducer,
  dashboardCards: dashboardCardsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);

export default store;